import { render, staticRenderFns } from "./ActivityHiddenVideoWithLabel.vue?vue&type=template&id=33ab0a4c"
import script from "./ActivityHiddenVideoWithLabel.vue?vue&type=script&lang=ts"
export * from "./ActivityHiddenVideoWithLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports